import { BP_DESKTOP } from './constants'
import { isMobile } from './helpers'

import Menu from '../modules/Menu'
import ServiceMenu from '../modules/ServiceMenu'
import PicUnveiler from '../modules/PicUnveiler'
import initEvents from './events'
// import initTransitions from '../modules/Transitions'
import { loadMatomo } from '../modules/Metrics/loader'

let Sliders = null
let Typewriter = null
let ContactFormFetch = null
let WorkshopFormFetch = null

export default class {
  constructor() {
    this.state = {
      resizeTimer: null,
      dragging: false,
      isMobile: isMobile(),
    }

    this.root = document.documentElement
    this.parser = new DOMParser()

    this.init()
  }

  initPage(page) {
    const requireCookiesBanner = false

    switch (page) {
      case 'waiting':
        this.initWaitingVideo()
        break
      case 'home':
        this.initSliders(['cases', 'posts'])
        this.initTypewriter('.typewriter', page)
        break

      case 'jobs':
        this.initTypewriter('.typewriter', page)
        break

      case 'about':
        this.initSliders(['about-pictures', 'employees'])
        break
      
      case 'service':
        this.initSliders(['cases'])
        break

      // @2021
      // case 'cases':
      // case 'service':
      //   this.initMasonry()
      //   break

      case 'contact':
        if ('contact' in document.forms) {
          this.initForms()
          this.initContactFormFetch()
        }
        break;

      case 'workshop':
        if ('workshop' in document.forms) {
          this.initForms()

          if (this.root.classList.contains('workshop--with-date')) {
            this.initWorkshopFormFetch()
          }
        }
        break;

      case 'workshopfeedback':
        if ('workshop-feedback' in document.forms) {
          this.initForms()
        }
        break;

      case 'feelsafeinstore':
      case 'prospect':
        this.initForms()
        // this.initTypewriter('.typewriter', page)
        break
    }

    loadMatomo() // temporary replacement for the line below
    // this.initCookiesManager(document.documentElement.dataset.cookieLevel, requireCookiesBanner)
  }

  destroyPage(page) {
    switch (page) {
      case 'home':
        this.destroySliders()
        this.destroyTypewriter()
        break

      case 'jobs':
        this.destroyTypewriter()
        break

      case 'about':
        this.destroySliders()
        break

      case 'cases':
      case 'service':
        this.destroyMasonry()
        break

      case 'contact':
        this.destroyContactFormFetch()
        break
    }
  }

  // initCookiesManager(cookiesType, requireCookiesBanner) {
  //   if (! ('cookiesManager' in this)) {
  //     import(/* webpackChunkName: "js/cookies-manager" */
  //       '../modules/CookiesManager').then(cookiesManagerModule => {
  //         this.cookiesManager = cookiesManagerModule.default(cookiesType, {
  //           'requireBanner': requireCookiesBanner,
  //         })
  //       }
  //     )
  //   }
  // }

  initForms() {
    if (! ('stackedFormLabels' in this)) {
      import(/* webpackChunkName: "js/stacked-forms-labels" */
        '../modules/StackedFormLabels').then(formLabelsModule => {
          this.stackedFormLabels = formLabelsModule.default()
        }
      )
    }
  }

  initContactFormFetch() {
    if (! ('contactFormFetch' in this)) {
      return import(/* webpackChunkName: "js/forms-fetch" */
      '../modules/ContactFormFetch').then(contactFormFetchModule => {
        ContactFormFetch = contactFormFetchModule.default
        this.contactFormFetch = new ContactFormFetch(this)
      })
    }

    this.contactFormFetch = new ContactFormFetch(this)
  }

  initWorkshopFormFetch() {
    if (! ('workshopFormFetch' in this)) {

      // This module is only useful to handle workshop dates.

      return import(/* webpackChunkName: "js/workshop-forms-fetch" */
      '../modules/WorkshopFormFetch').then(workshopFormFetchModule => {
        WorkshopFormFetch = workshopFormFetchModule.default
        this.workshopFormFetch = new WorkshopFormFetch(this)
      })
    }

    this.contactFormFetch = new ContactFormFetch(this)
  }

  // @2021
  // initMasonry() {
  //   if ('casesMasonry' in this) {
  //     return this.casesMasonry.init()
  //   }

  //   import(/* webpackChunkName: "js/cases-masonry" */
  //   '../modules/CasesMasonry').then(casesMasonryModule => {
  //     this.casesMasonry = casesMasonryModule.default()
  //   })
  // }

  initSliders(sliders = []) {
    if (! ('sliders' in this)) {
      return import(/* webpackChunkName: "js/sliders" */
      '../modules/Sliders').then(slidersModule => {
        Sliders = slidersModule.default
        this.sliders = new Sliders(sliders)
      })
    }

    this.sliders = new Sliders(sliders)
  }

  initTypewriter(selector, page) {
    if (! ('typewriter' in this)) {
      return import(/* webpackChunkName: "js/typewriter" */
      '../modules/Typewriter').then(typewriterModule => {
        Typewriter = typewriterModule.default
        this.typewriter = new Typewriter(selector, page)
      })
    }

    this.typewriter = new Typewriter(selector, page)
  }

  destroyContactFormFetch() {
    delete this.contactFormFetch
  }

  destroyMasonry() {
    if ('casesMasonry' in this) {
      this.casesMasonry.destroy()
    }
  }

  destroySliders() {
    if (! ('sliders' in this)) { return }

    this.sliders.destroy()
    delete this.sliders
  }

  destroyTypewriter() {
    if (! ('typewriter' in this)) { return }

    this.typewriter.destroy()
    delete this.typewriter
  }


  initWaitingVideo() {
    const desktopMQ = window.matchMedia('(min-width: 896px)')
    const $video = document.querySelector('.wVideoCtn__video')

    if ($video) {
      desktopMQ.addListener(() => {
        $video.load()
      })
    }
  }


  init() {
    this.root.classList.remove('no-js', 'js-loading')
    this.root.classList.add('js', 'transitioning')

    this.serviceMenu = new ServiceMenu(this.state.isMobile)
    this.menu = new Menu(this.root)
    // this.picUnveiler = new PicUnveiler()

    initEvents(this)
    // initTransitions(this)
  }
}



// WEBPACK FOOTER //
// ./resources/js/app/index.js